import PropTypes from "prop-types";
import { SignType } from "../../../domain";
import formatFulfillerNames from "../../../util/formatFulfillerNames.js";
import { usd } from "../../../util/formatCurrency.js";
import Drawer from "./Drawer.jsx";
import s from "./CustomUploadDrawer.module.css";
import { Typography } from "../../../themeV2";

export default function CustomUploadDrawer({
  open,
  products,
  onSelect,
  onClose,
}) {
  if (!open) return null;

  const showAvatars = products.some((p) =>
    p.fulfillers?.some((f) => f.avatar_url),
  );
  const signingTypes = new Set(products.map((p) => p.signed_type));
  const showSigningType = signingTypes.size > 1;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Custom artwork signing"
      ariaLabel="Custom artwork signing"
    >
      <Typography
        variant="label-lg"
        color="variant"
        weight="bold"
        as="div"
        className={s.label}
      >
        Choose an option
      </Typography>
      <div className={s.options}>
        {products.map((p) => {
          const fulfillers = p.fulfillers || [];
          const displayName = formatFulfillerNames(fulfillers) || p.name;
          const avatars = fulfillers.filter((f) => f.avatar_url);
          return (
            <button
              key={p.product_id}
              className={s.option}
              onClick={() => onSelect(p)}
            >
              <div className={s.optionLeft}>
                {showAvatars && avatars.length > 0 && (
                  <div
                    className={s.avatarStack}
                    style={{
                      width: `calc(2.5rem + ${(avatars.length - 1) * 1.25}rem)`,
                    }}
                  >
                    {avatars.map((f, i) => (
                      <img
                        key={f.name}
                        className={s.avatar}
                        src={f.avatar_url}
                        alt={f.name}
                        style={{
                          left: `${i * 1.25}rem`,
                          zIndex: avatars.length - i,
                        }}
                      />
                    ))}
                  </div>
                )}
                <div className={s.optionInfo}>
                  <p className={s.optionName}>{displayName}</p>
                  {showSigningType && (
                    <p className={s.optionType}>
                      {SignType.toLabel(p.signed_type)}
                    </p>
                  )}
                </div>
              </div>
              <span className={s.optionPrice}>{usd(p._totalPrice)}</span>
            </button>
          );
        })}
      </div>
    </Drawer>
  );
}

CustomUploadDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(
    PropTypes.shape({
      product_id: PropTypes.number.isRequired,
      name: PropTypes.string,
      signed_type: PropTypes.string,
      _totalPrice: PropTypes.number,
      fulfillers: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          avatar_url: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
